import React, { useEffect } from 'react';
import { Button, Divider, Form, Input, message, Spin } from 'antd';
import { LoadingOutlined, SaveOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useLayoutContext } from '../../../../Layout/context';
import useUnsavedChanges from '../../../../../hooks/unsavedChanges';
import useComponentDidUpdate from '../../../../../hooks/componentDidUpdate';
import Content from '../../../../Common/Content';
import PageForm from '../../Form';
import { useMessageError } from '../../../../../hooks/common';
import { useInternationalGetById, useInternationalUpdate } from '../../../../../hooks/api/internationals';
import Comments from '../../../Comments';

import styles from './index.module.scss';

export default function InternationalUpdate(): JSX.Element {
  const [form] = Form.useForm();
  const { internationalId } = useParams();
  const internationalByIdFetchGet = useInternationalGetById(internationalId);
  const internationalUpdate = useInternationalUpdate(internationalId);
  const navigate = useNavigate();
  const { setBreadcrumbs } = useLayoutContext();
  const { setInitData, check, setChanged, contextHolder, isChanged } = useUnsavedChanges();

  useMessageError([internationalByIdFetchGet, internationalUpdate]);

  useEffect(() => {
    internationalByIdFetchGet.fetch();
    setBreadcrumbs([
      { title: 'Tipping internationals', href: '/internationals' },
      { title: <Spin size="small" indicator={<LoadingOutlined spin />} /> },
    ]);
  }, []);

  useComponentDidUpdate(() => {
    if (internationalByIdFetchGet.data && !internationalByIdFetchGet.loading && !internationalByIdFetchGet.error) {
      setBreadcrumbs([
        {
          title: 'Tipping internationals',
          href: '/internationals',
        },
        {
          title: internationalByIdFetchGet.data?.country?.name?.slice(0, 100),
        },
      ]);

      setTimeout(() => setInitData(form.getFieldsValue()), 100);
    }
  }, [internationalByIdFetchGet.data]);

  useEffect(() => {
    if (internationalUpdate.data && !internationalUpdate.error && !internationalUpdate.loading) {
      message.success('Page update successfully');
      navigate('/internationals');
    }
  }, [internationalUpdate.data, internationalUpdate.loading]);

  return (
    <>
      <div className={styles.header}>
        <h2>Update international page</h2>
        <div className={styles.actions}>
          <Button
            onClick={(e) => {
              e.preventDefault();
              // navigate('/categories');
              window.location.reload();
            }}
          >
            Cancel
          </Button>
          <Button
            icon={<SaveOutlined />}
            type="primary"
            loading={internationalByIdFetchGet.loading || internationalUpdate.loading}
            onClick={() => {
              form.submit();
            }}
            disabled={!isChanged}
          >
            Save Changes
          </Button>
        </div>
      </div>

      <Content className={styles.content}>
        {internationalByIdFetchGet.data ? (
          <Form
            initialValues={{
              ...internationalByIdFetchGet.data,
              countryId: internationalByIdFetchGet.data.country.id,
              seo: {
                ...internationalByIdFetchGet.data.seo,
                data: JSON.stringify(internationalByIdFetchGet.data.seo.data),
              },
            }}
            layout="vertical"
            className={styles.main}
            form={form}
            onFinish={(data) => {
              console.log(123);
              console.log(data);

              setInitData(data);
              console.log(1);

              const { internationalId: _, ...values } = data;

              console.log(2);

              internationalUpdate.fetch({
                ...values,
                seo: {
                  ...values.seo,
                  data: values.seo.data ? JSON.parse(values.seo.data) : '{}',
                },
              });
            }}
            onChange={() => setChanged(check(form.getFieldsValue()))}
          >
            <Form.Item
              style={{ display: 'none' }}
              name={['seo', 'id']}
            >
              <Input
                placeholder="home-page"
              />
            </Form.Item>
            <PageForm
              loading={internationalByIdFetchGet.loading}
              form={form}
              onChange={() => setChanged(check(form.getFieldsValue()))}
            />
          </Form>
        ) : null}
      </Content>

      {contextHolder}

      <div>
        <Divider orientation="left" plain orientationMargin={16} className="divider">
          <span className="dividerText">Comments</span>
        </Divider>

        <Comments
          loading={internationalByIdFetchGet.loading}
          hideTitle
          filter={{
            entity: 'international_community',
            international: internationalId,
          }}
        />
      </div>
    </>
  );
}
